import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppState } from 'src/store';
import { getLinkByorganizationIdAndService } from 'src/store/organization/thunks';

interface TableProps {
    getLinkByorganizationIdAndService?: any;

}
const PowerBI: React.FC<TableProps> = (props: TableProps) => {
    interface RouteParams {
        idOrganization: string;
        typeEvent: string;
    }
    const params = useParams<RouteParams>();
    const [isUrlLinkButtom, setIsUrlLinkButtom] = useState("");
    useEffect(() => {        
        const fetchData = async () => {                        
            const responseData = await props.getLinkByorganizationIdAndService(params.idOrganization,params.typeEvent);
            if (responseData !== undefined) {
                setIsUrlLinkButtom(responseData.url);
            } else {
                setIsUrlLinkButtom("");
            }
        };

        fetchData();
    }, [props.getLinkByorganizationIdAndService]);
    return (
        <div style={{ width: '100%', height: '100vh' }}>
            <iframe
                title="Power BI Report"
                width="100%"
                height="100%"
                src={isUrlLinkButtom}
                allowFullScreen={true}
            ></iframe>
        </div>
    );
};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getLinkByorganizationIdAndService
})(PowerBI);